
<div class="header-toolbar">
  <h1>{{ title }}</h1>
</div>

<form #form="ngForm" (ngSubmit)="save()" autocomplete="off">

  <!-- Toolbar -->
  <div class="main btn-toolbar">
        
    <button class="btn" type="submit" [disabled]="!entity">
      <t-icon name="check"></t-icon>
      <span class="text">Enregistrer</span>
    </button>

    &nbsp;

    <a class="btn" (click)="cancel()">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>
  <!-- /Toolbar -->

  <div class="grid">

    <div class="column">

      <div class="panel">
        <h2>Dossier</h2>

        <div class="form-group">
          <label>Entité</label>

          <span id="type" class="value">{{ entity?.name || '-' }}</span>
          <span class="info">Veuillez sélectionner une entité</span>

          <div class="text-right">
            <a class="btn btn-small btn-gray" title="Sélectionner une entité" (click)="lookupEntity($event)">
              <t-icon name="search"></t-icon>
              <span class="text">Recherche</span>
            </a>
          </div>

        </div>
      </div>
      
    </div>

    <div class="column"></div>

  </div>
</form>